<template>
    <div data-cy="container_mission_checkin_days">
        <div>
            <div class="-mt-6 mb-4" v-show="isCheckIn == 0">
                <img class="w-full" data-cy="img_mission_checkin_day_0" :src="imgCheckinUrl(0)" alt="">
            </div>
            <div class="-mt-6 mb-4" v-show="isCheckIn == 1">
                <img class="w-full" data-cy="img_mission_checkin_day_1" :src="imgCheckinUrl(1)" alt="">
            </div>
            <div class="-mt-6 mb-4" v-show="isCheckIn == 2">
                <img class="w-full" data-cy="img_mission_checkin_day_2" :src="imgCheckinUrl(2)" alt="">
            </div>
            <div class="-mt-6 mb-4" v-show="isCheckIn == 3">
                <img class="w-full" data-cy="img_mission_checkin_day_3" :src="imgCheckinUrl(3)" alt="">
            </div>
            <div class="-mt-6 mb-4" v-show="isCheckIn == 4">
                <img class="w-full" data-cy="img_mission_checkin_day_4" :src="imgCheckinUrl(4)" alt="">
            </div>
            <div class="-mt-6 mb-4" v-show="isCheckIn == 5">
                <img class="w-full" data-cy="img_mission_checkin_day_5" :src="imgCheckinUrl(5)" alt="">
            </div>
            <div class="-mt-6 mb-4" v-show="isCheckIn == 6">
                <img class="w-full" data-cy="img_mission_checkin_day_6" :src="imgCheckinUrl(6)" alt="">
            </div>
            <div class="-mt-6 mb-4" v-show="isCheckIn == 7">
                <img class="w-full" data-cy="img_mission_checkin_day_7" :src="imgCheckinUrl(7)" alt="">
            </div>
        </div>
    </div>
</template>
<script>
//library
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ConfigManager from '@/config/ConfigManager.js';
export default {
    mixins: [LocaleMixin],
    props: {
        isCheckIn:  { type: Number, required: true },
    },
    data: function() {
        return {

        }
    },
    created: function() {

    },
    methods: {
        imgCheckinUrl: function(day) {
            var appId = ConfigManager.getAppId();
            return ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/image/checkin/day-${day}.png`;
        },
    }
}
</script>
<style lang="scss">
#checkin-slide{
    .splide__track {
        .splide__list {
            .splide__slide {
                padding-right: 5px;
            }
        }
    }
    .splide__pagination{
        display: none;
    }
}
.box-page {
    margin-top: 18px;
}
</style>
